// import { DatePicker, Select } from 'common/InputForm';
// import NotFound from 'common/NotFound';
// import useDebounce from 'common/UseDebounce';
// import useFullPageLoader from 'common/UseFullPageLoader';
// import { SearchBar } from 'components/form';
// import React, { useContext, useEffect, useState } from 'react'
// import { FaEye } from 'react-icons/fa';
// import Pagination from 'react-js-pagination';
// import { useNavigate, useSearchParams } from 'react-router-dom';
// import { dateFormat, formatCustomDate } from 'utils/dateFormat';
// import findSerialNumber from 'utils/findSerialNumber';
// import { LiaShippingFastSolid } from "react-icons/lia";
// import { orderListApi } from 'services/orderManagement';
// import { isHighlighted, markRowOpened, subscribeSeen, orderSeenId } from 'utils/seenNotifications';
// import OrderContext from 'context/orderContext/OrderContext';
// import { useDispatch, useSelector } from 'react-redux';
// import { fetchOrderList } from 'store/orderSlice/OrderSlice';

// const OrderManagement = () => {
//     const [searchParams, setSearchParams] = useSearchParams();
//     const navigate = useNavigate();
//     const [loader, onShow, onHide] = useFullPageLoader();
//     const activePage = +searchParams.get("page") || 1;
//     const limit = +searchParams.get("limit") || 10;
//     const userStatus = searchParams.get("status") || "";
//     const search = searchParams.get("search") || "";
//     const debouncedValue = useDebounce(search, 300);
//     const [total, setTotal] = useState(0);
//     const [orderList, setOrderList] = useState([])
//     const [input, setInput] = useState({ startDate: '', orderStatus: '',orderType:'' })
//     const { order } = useContext(OrderContext)
//     const dispatch = useDispatch();
//     const { data, loading, error } = useSelector((state) => state.order);
//     // console.log('order--->>', data)

//     // ---- notification row highlight: only the order the admin picked via
//     // "View & Handle" stays light green, until its row is opened here ----
//     const [, setSeenTick] = useState(0);
//     useEffect(() => subscribeSeen(() => setSeenTick((n) => n + 1)), []);
//     const isRowNew = (row) =>
//         row?.orderStatus === 'PENDING' && isHighlighted(orderSeenId(row?._id));
//     const handleOpenRow = (row) => {
//         if (row?._id) markRowOpened(orderSeenId(row._id));
//     };
//     //-----------Handel-Pagination-----------
//     const handlePageChange = (event) => {
//         const newParams = new URLSearchParams(searchParams);
//         newParams.set("page", event);
//         setSearchParams(newParams);
//     };
//     // ----------handle-search-------------
//     const handleSearch = (e) => {
//         const newParams = new URLSearchParams(searchParams);
//         newParams.set("search", e.target.value);
//         newParams.set("page", 1);
//         setSearchParams(newParams);
//     }
//     // ----------handle-payment-mode-------------

//     // Remove handleDeliveryStatus and handleOrderType
// // Replace both with one handler:

// const handleInputChange = (e) => {
//     const { name, value } = e.target;
//      console.log(value,"Value")
//     setInput(prev => ({ ...prev, [name]: value })); // ✅ uses prev state, no overwrite risk
// };
//     const handleDeliveryStatus = (e) => {
//         const { name, value } = e.target;
//          console.log(name,value," helloe")
//         setInput({ ...input, [name]: value })
//     }
//      // ----------Order Status -------------

//       const handleOrderType = (e) => {
//         const { name, value } = e.target;
//          console.log(name,value," helloe")
//         setInput({ ...input, [name]: value })
//     }
//     // ----------handle-date-change-------------
//     const handleDateChange = (name, value) => {
//         const formatDate = value
//         setInput({ ...input, [name]: formatDate })
//     }
//     // ----------Listing-API-------------------
//     // useEffect(() => {
//     //     const fetchOrderList = async () => {
//     //         const query = {
//     //             page: activePage || '',
//     //             search: debouncedValue || '',
//     //             startDate: input.startDate || '',
//     //             orderStatus: input.orderStatus || '',
//     //         };
//     //         onShow();
//     //         try {
//     //             const res = await orderListApi(query);
//     //             const { code, data } = res?.data;
//     //             if (code === 200) {
//     //                 setOrderList(data?.data || []);
//     //                 setTotal(data?.total || 0)
//     //             }
//     //         } catch (error) {
//     //             console.log(error);
//     //         } finally {
//     //             onHide();
//     //         }
//     //     };
//     //     fetchOrderList();
//     // }, [activePage, debouncedValue, input?.startDate, input?.orderStatus]);
//     // useEffect(() => {
//     //     const query = {
//     //         page: activePage || '',
//     //         search: debouncedValue || '',
//     //         startDate: input.startDate || '',
//     //         orderStatus: input.orderStatus || '',
//     //         orderType :input.orderType || ''
//     //     };
//     //     dispatch(fetchOrderList(query));
//     // }, [activePage, debouncedValue, input, dispatch]);




//     useEffect(() => {
//     const query = {
//         page: activePage || '',
//         search: debouncedValue || '',
//         startDate: input.startDate || '',
//         orderStatus: input.orderStatus || '',
//         orderType: input.orderType || ''
//     };

//     dispatch(fetchOrderList(query));

// }, [
//     activePage,
//     debouncedValue,
//     input.startDate,
//     input.orderStatus,
//     input.orderType,
//     dispatch
// ]);
//     useEffect(() => {
//         setOrderList(data?.data || []);
//         setTotal(data?.total || 0);
//     }, [data]);
//     return (
//         <div className="prescription-management-parent">
//             {loader}
//             <div className="page_title">
//                 <h3>Order Management</h3>
//             </div>

//             <div className="search_wrapper">
//                 <SearchBar
//                     placeholder="Search..."
//                     onChange={handleSearch}
//                     value={search}
//                 />

//                 <div>
//                     <DatePicker
//                         name="startDate"
//                         selected={input?.startDate}
//                         placeholder="Start Date"
//                         isClearable
//                         onChange={(date) => handleDateChange('startDate', date)}
//                     />



             
//                 </div>
//                 <div>
//                     <Select
//                         className="select-status-option"
//                         name='orderStatus'
//                         value={input?.orderStatus}
//                         onChange={handleDeliveryStatus}
//                     >
//                         <option value="">Delivery Status</option>
//                         <option value="PENDING">Pending</option>
//                         <option value="ACCEPTED">Accepted</option>
//                         <option value="PROCESSING">Processing</option>
//                         <option value="OUT_FOR_DELIVERY">Out for Delivery</option>
//                         <option value="IS_READY_TO_PICK">Ready to Pick</option>
//                         <option value="DELIVERED">Delivered</option>
//                         <option value="CANCELLED">Cancelled</option>
//                     </Select>
//                 </div>



//                   <div>
//                     <Select
//                         className="select-status-option"
//                         name='orderType'
//                         value={input?.orderType}
//                         onChange={handleInputChange}
//                     >
//                         <option value="">Order Type</option>
//                         <option value="PICKUP">Store Pick UP</option>
//                         <option value="DELIVERY"> Home Delivery</option>
                  
//                     </Select>
//                 </div>
//             </div>
//             {/* -----main card */}
//             <div className="card">
//                 <div className="table-container">
//                     <table className="table custom_table">
//                         <thead>
//                             <tr>
//                                 <th className="nowrap text-center">S.No</th>
//                                 <th className="nowrap text-center">C.ID</th>
//                                 <th className="nowrap text-center">O.ID</th>
//                                 <th className="nowrap text-center">C. Name</th>
//                                 <th className="nowrap text-center">Order Date & Time</th>
//                                 <th className="nowrap text-center">Delivery Status & Time</th>
//                                 <th className="nowrap text-center">Payment Mode</th>
//                                 <th className="nowrap text-center">Price</th>
//                                 <th className="nowrap text-center">Action</th>
//                             </tr>
//                         </thead>

//                         <tbody>
//                             {orderList && orderList.length ? (
//                                 orderList?.map((data, index) => {
//                                     return (
//                                         <tr key={index}
//                                             style={isRowNew(data) ? {
//                                                 backgroundColor: '#d1e7dd',
//                                                 boxShadow: 'inset 4px 0 0 #198754',
//                                             } : undefined}
//                                             onClick={() => {
//                                                             handleOpenRow(data);
//                                                             navigate(
//                                                                 `/order-management/order-details/${data._id}`
//                                                             );
//                                                         }}>
//                                             <td className="nowrap text-center">
//                                                 {findSerialNumber(index, activePage, limit)}
//                                             </td>

//                                             {/* <td className="nowrap text-center">
//                                                 {data?.user?.customerId || "N/A"}cc
//                                             </td> */}


//                                             <td
//   className="nowrap text-center"
//   onClick={(e) => {
//     e.stopPropagation();
//     // your logic here
//   }}
// >
//   {data?.user?.customerId || "N/A"}
  
// </td>




//                                             <td
//   className="nowrap text-center"
//   onClick={(e) => {
//     e.stopPropagation();
//     // your logic here
//   }}
// >
//                                                 {data?.orderId ? `#${data?.orderId}` : "N/A"}
// </td>
//                                             {/* <td className="nowrap text-center" >
//                                                 {data?.orderId ? `#${data?.orderId}` : "N/A"}
//                                             </td> */}
//                                             <td className="nowrap text-center"  onClick={(e) => {
//     e.stopPropagation();
//     // your logic here
//   }}>
//                                                 {data?.user?.fullName || "N/A"}
//                                             </td>

//                                             <td className="nowrap text-center">
//                                                 {formatCustomDate(data?.createdAt, 'DD-MM-YY, HH:mm') || "N/A"}
//                                             </td>

//                                             <td className="nowrap text-center">
// {/* 
//                                                 {
//   `${{
//     IS_READY_TO_PICK: "Ready to Pick",
//     PENDING: "Pending",
//     DELIVERED: "Delivered",
//     CANCELLED: "Cancelled",
//   }[data?.orderStatus] || data?.orderStatus || "N/A"},
//   ${formatCustomDate(data?.createdAt)}`
// } */}



// <span
//   style={{
//     color:
//       data?.orderStatus === "PROCESSING"
//         ? "green"
//         : data?.orderStatus === "PENDING"
//         ? "#800080" // dark purple
//         : "black",
//     fontWeight:
//       ["PROCESSING", "PENDING"].includes(data?.orderStatus)
//         ? "bold"
//         : "normal",
//   }}
// >
//   {{
//     IS_READY_TO_PICK: "Ready to Pick",
//     PROCESSING: "Processing",
//     PENDING: "Pending",
//     DELIVERED: "Delivered",
//     CANCELLED: "Cancelled",
//     OUT_FOR_DELIVERY: "Out for Delivery",
//   }[data?.orderStatus] || data?.orderStatus || "N/A"}
//   {`, ${formatCustomDate(data?.createdAt)}`}
// </span>
//                                             </td>
//                                             <td className="nowrap text-center">
//                                                 {data?.paymentMode || "N/A"}
//                                             </td>
//                                             <td className="nowrap text-center">
//                                                 {data?.total ? `Rs.${data?.total}` : "N/A"}
//                                             </td>
//                                             <td className="nowrap text-center">
//                                                 <div className="icon_wrap">
//                                                     <button
//                                                         className="icon_button"
//                                                         onClick={() => {
//                                                             navigate(
//                                                                 `/order-management/order-details/${data._id}`
//                                                             );
//                                                         }}
//                                                     >
//                                                         <FaEye />
//                                                     </button>
//                                                 </div>
//                                             </td>
//                                         </tr>
//                                     );
//                                 })
//                             ) : (
//                                 <NotFound
//                                     cols={9}
//                                     msg={"Order data not found"}
//                                     onHide={onHide}
//                                     icon={<LiaShippingFastSolid />}
//                                 />
//                             )}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>

//             {total > limit && (
//                 <div className="pagination-wrapper">
//                     <div className="Pagination">
//                         <Pagination
//                             activePage={activePage}
//                             previousLabel={"previous"}
//                             nextLabel={"next"}
//                             itemsCountPerPage={limit}
//                             totalItemsCount={total}
//                             pageRangeDisplayed={5}
//                             onChange={handlePageChange}
//                             hideDisabled={true}
//                         />
//                     </div>
//                 </div>
//             )}
//         </div>
//     )
// }

// export default OrderManagement

















import { DatePicker, Select } from 'common/InputForm';
import NotFound from 'common/NotFound';
import useDebounce from 'common/UseDebounce';
import useFullPageLoader from 'common/UseFullPageLoader';
import { SearchBar } from 'components/form';
import React, { useContext, useEffect, useState } from 'react'
import { FaEye } from 'react-icons/fa';
import Pagination from 'react-js-pagination';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { dateFormat, formatCustomDate } from 'utils/dateFormat';
import findSerialNumber from 'utils/findSerialNumber';
import { LiaShippingFastSolid } from "react-icons/lia";
import { orderListApi } from 'services/orderManagement';
import { isHighlighted, markRowOpened, subscribeSeen, orderSeenId } from 'utils/seenNotifications';
import OrderContext from 'context/orderContext/OrderContext';
import { useDispatch, useSelector } from 'react-redux';
import { fetchOrderList } from 'store/orderSlice/OrderSlice';

const OrderManagement = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();
    const [loader, onShow, onHide] = useFullPageLoader();
    const activePage = +searchParams.get("page") || 1;
    const limit = +searchParams.get("limit") || 10;
    const userStatus = searchParams.get("status") || "";
    const search = searchParams.get("search") || "";
    const debouncedValue = useDebounce(search, 300);
    const [total, setTotal] = useState(0);
    const [orderList, setOrderList] = useState([])
    const [input, setInput] = useState({ startDate: '', orderStatus: '', orderType: '' })
    const { order } = useContext(OrderContext)
    const dispatch = useDispatch();
    const { data, loading, error } = useSelector((state) => state.order);
    // console.log('order--->>', data)

    // ---- notification row highlight: only the order the admin picked via
    // "View & Handle" stays light green, until its row is opened here ----
    const [, setSeenTick] = useState(0);
    useEffect(() => subscribeSeen(() => setSeenTick((n) => n + 1)), []);
    const isRowNew = (row) =>
        row?.orderStatus === 'PENDING' && isHighlighted(orderSeenId(row?._id));
    const handleOpenRow = (row) => {
        if (row?._id) markRowOpened(orderSeenId(row._id));
    };

    // ---- centralized row click: navigates unless the click originated
    // inside an element explicitly marked with data-no-row-click.
    // More reliable across browsers than relying purely on
    // e.stopPropagation() inside every individual <td>. ----
    const handleRowClick = (e, row) => {
        if (e.target.closest('[data-no-row-click]')) return;
        handleOpenRow(row);
        navigate(`/order-management/order-details/${row._id}`);
    };

    //-----------Handel-Pagination-----------
    const handlePageChange = (event) => {
        const newParams = new URLSearchParams(searchParams);
        newParams.set("page", event);
        setSearchParams(newParams);
    };
    // ----------handle-search-------------
    const handleSearch = (e) => {
        const newParams = new URLSearchParams(searchParams);
        newParams.set("search", e.target.value);
        newParams.set("page", 1);
        setSearchParams(newParams);
    }
    // ----------handle-payment-mode-------------

    // Remove handleDeliveryStatus and handleOrderType
    // Replace both with one handler:

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        console.log(value, "Value")
        setInput(prev => ({ ...prev, [name]: value })); // ✅ uses prev state, no overwrite risk
    };
    const handleDeliveryStatus = (e) => {
        const { name, value } = e.target;
        console.log(name, value, " helloe")
        setInput({ ...input, [name]: value })
    }
    // ----------Order Status -------------

    const handleOrderType = (e) => {
        const { name, value } = e.target;
        console.log(name, value, " helloe")
        setInput({ ...input, [name]: value })
    }
    // ----------handle-date-change-------------
    const handleDateChange = (name, value) => {
        const formatDate = value
        setInput({ ...input, [name]: formatDate })
    }
    // ----------Listing-API-------------------
    // useEffect(() => {
    //     const fetchOrderList = async () => {
    //         const query = {
    //             page: activePage || '',
    //             search: debouncedValue || '',
    //             startDate: input.startDate || '',
    //             orderStatus: input.orderStatus || '',
    //         };
    //         onShow();
    //         try {
    //             const res = await orderListApi(query);
    //             const { code, data } = res?.data;
    //             if (code === 200) {
    //                 setOrderList(data?.data || []);
    //                 setTotal(data?.total || 0)
    //             }
    //         } catch (error) {
    //             console.log(error);
    //         } finally {
    //             onHide();
    //         }
    //     };
    //     fetchOrderList();
    // }, [activePage, debouncedValue, input?.startDate, input?.orderStatus]);
    // useEffect(() => {
    //     const query = {
    //         page: activePage || '',
    //         search: debouncedValue || '',
    //         startDate: input.startDate || '',
    //         orderStatus: input.orderStatus || '',
    //         orderType :input.orderType || ''
    //     };
    //     dispatch(fetchOrderList(query));
    // }, [activePage, debouncedValue, input, dispatch]);




    useEffect(() => {
        const query = {
            page: activePage || '',
            search: debouncedValue || '',
            startDate: input.startDate || '',
            orderStatus: input.orderStatus || '',
            orderType: input.orderType || ''
        };

        dispatch(fetchOrderList(query));

    }, [
        activePage,
        debouncedValue,
        input.startDate,
        input.orderStatus,
        input.orderType,
        dispatch
    ]);
    useEffect(() => {
        setOrderList(data?.data || []);
        setTotal(data?.total || 0);
    }, [data]);
    return (
        <div className="prescription-management-parent">
            {loader}
            <div className="page_title">
                <h3>Order Management</h3>
            </div>

            <div className="search_wrapper">
                <SearchBar
                    placeholder="Search..."
                    onChange={handleSearch}
                    value={search}
                />

                <div>
                    <DatePicker
                        name="startDate"
                        selected={input?.startDate}
                        placeholder="Start Date"
                        isClearable
                        onChange={(date) => handleDateChange('startDate', date)}
                    />




                </div>
                <div>
                    <Select
                        className="select-status-option"
                        name='orderStatus'
                        value={input?.orderStatus}
                        onChange={handleDeliveryStatus}
                    >
                        <option value="">Delivery Status</option>
                        <option value="PENDING">Pending</option>
                        <option value="ACCEPTED">Accepted</option>
                        <option value="PROCESSING">Processing</option>
                        <option value="OUT_FOR_DELIVERY">Out for Delivery</option>
                        <option value="IS_READY_TO_PICK">Ready to Pick</option>
                        <option value="DELIVERED">Delivered</option>
                        <option value="CANCELLED">Cancelled</option>
                    </Select>
                </div>



                <div>
                    <Select
                        className="select-status-option"
                        name='orderType'
                        value={input?.orderType}
                        onChange={handleInputChange}
                    >
                        <option value="">Order Type</option>
                        <option value="PICKUP">Store Pick UP</option>
                        <option value="DELIVERY"> Home Delivery</option>

                    </Select>
                </div>
            </div>
            {/* -----main card */}
            <div className="card">
                <div className="table-container">
                    <table className="table custom_table">
                        <thead>
                            <tr>
                                <th className="nowrap text-center">S.No</th>
                                <th className="nowrap text-center">C.ID</th>
                                <th className="nowrap text-center">O.ID</th>
                                <th className="nowrap text-center">C. Name</th>
                                <th className="nowrap text-center">Order Date & Time</th>
                                <th className="nowrap text-center">Delivery Status & Time</th>
                                <th className="nowrap text-center">Payment Mode</th>
                                <th className="nowrap text-center">Price</th>
                                <th className="nowrap text-center">Action</th>
                            </tr>
                        </thead>

                        <tbody>
                            {orderList && orderList.length ? (
                                orderList?.map((data, index) => {
                                    return (
                                        <tr key={index}
                                            style={isRowNew(data) ? {
                                                backgroundColor: '#d1e7dd',
                                                boxShadow: 'inset 4px 0 0 #198754',
                                            } : undefined}
                                            onClick={(e) => handleRowClick(e, data)}
                                        >
                                            <td className="nowrap text-center">
                                                {findSerialNumber(index, activePage, limit)}
                                            </td>

                                            {/* Cells marked data-no-row-click are excluded from
                                                triggering the row navigation. Add your own
                                                click logic inside these without worrying about
                                                the row's onClick firing too. */}
                                            <td
                                                className="nowrap text-center"
                                                data-no-row-click
                                                onClick={(e) => {
                                                    // your logic here
                                                }}
                                            >
                                                {data?.user?.customerId || "N/A"}
                                            </td>

                                            <td
                                                className="nowrap text-center"
                                                data-no-row-click
                                                onClick={(e) => {
                                                    // your logic here
                                                }}
                                            >
                                                {data?.orderId ? `#${data?.orderId}` : "N/A"}
                                            </td>

                                            <td
                                                className="nowrap text-center"
                                                data-no-row-click
                                                onClick={(e) => {
                                                    // your logic here
                                                }}
                                            >
                                                {data?.user?.fullName || "N/A"}
                                            </td>

                                            <td className="nowrap text-center">
                                                {formatCustomDate(data?.createdAt, 'DD-MM-YY, HH:mm') || "N/A"}
                                            </td>

                                            <td className="nowrap text-center">
                                                <span
                                                    style={{
                                                        color:
                                                            data?.orderStatus === "PROCESSING"
                                                                ? "green"
                                                                : data?.orderStatus === "PENDING"
                                                                    ? "#800080" // dark purple
                                                                    : "black",
                                                        fontWeight:
                                                            ["PROCESSING", "PENDING"].includes(data?.orderStatus)
                                                                ? "bold"
                                                                : "normal",
                                                    }}
                                                >
                                                    {{
                                                        IS_READY_TO_PICK: "Ready to Pick",
                                                        PROCESSING: "Processing",
                                                        PENDING: "Pending",
                                                        DELIVERED: "Delivered",
                                                        CANCELLED: "Cancelled",
                                                        OUT_FOR_DELIVERY: "Out for Delivery",
                                                    }[data?.orderStatus] || data?.orderStatus || "N/A"}
                                                    {`, ${formatCustomDate(data?.createdAt)}`}
                                                </span>
                                            </td>
                                            <td className="nowrap text-center">
                                                {data?.paymentMode || "N/A"}
                                            </td>
                                            <td className="nowrap text-center">
                                                {data?.total ? `Rs.${data?.total}` : "N/A"}
                                            </td>
                                            <td className="nowrap text-center" data-no-row-click>
                                                <div className="icon_wrap">
                                                    <button
                                                        className="icon_button"
                                                        onClick={() => {
                                                            navigate(
                                                                `/order-management/order-details/${data._id}`
                                                            );
                                                        }}
                                                    >
                                                        <FaEye />
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })
                            ) : (
                                <NotFound
                                    cols={9}
                                    msg={"Order data not found"}
                                    onHide={onHide}
                                    icon={<LiaShippingFastSolid />}
                                />
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {total > limit && (
                <div className="pagination-wrapper">
                    <div className="Pagination">
                        <Pagination
                            activePage={activePage}
                            previousLabel={"previous"}
                            nextLabel={"next"}
                            itemsCountPerPage={limit}
                            totalItemsCount={total}
                            pageRangeDisplayed={5}
                            onChange={handlePageChange}
                            hideDisabled={true}
                        />
                    </div>
                </div>
            )}
        </div>
    )
}

export default OrderManagement